import { FormHelperText as MaterialFormHelperText } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';

export const StyledFormHelperText = withStyles(({ typography, palette }) => ({
  root: {
    ...typography.caption,
    fontWeight: 900,
    color: palette.error.main,
    padding: '0 15px',
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
}))(MaterialFormHelperText);

export const useStyles = makeStyles(({ palette }) => ({
  success: {
    color: palette.primary.main,
  },
}));
